// extracted by mini-css-extract-plugin
export default {"recos":"Q6-z","productCardOverride":"R6-z","rowHasBadge":"S6-z"};